import { createActionGroup, props } from "@ngrx/store";
import { Location } from "src/api-service";
import { AppError } from "../../../../app-store-error.types";

export const DataLocationsActions = createActionGroup({
    source: "Data / Locations",
    events: {
        "Load": props<{ companyId: string; languageCode: string }>(),
        "Load Success": props<{ locations: Location[] }>(),
        "Load Failure": props<{ error: AppError; toastKey: string }>(),
    },
});
